var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgVioletLinkedin = function SvgVioletLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 15 14"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#5F2DD3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.188 13.956h.003V9.01c0-2.42-.52-4.283-3.349-4.283-1.359 0-2.272.746-2.644 1.454h-.039V4.953H5.478v9.002H8.27V9.498c0-1.174.223-2.308 1.676-2.308 1.432 0 1.454 1.339 1.454 2.384v4.382h2.788ZM.93 4.954h2.796v9.002H.93V4.954ZM2.327.472a1.62 1.62 0 0 0-1.619 1.62c0 .893.726 1.633 1.619 1.633s1.619-.74 1.619-1.634A1.62 1.62 0 0 0 2.326.472Z"
  }))));
};
export default SvgVioletLinkedin;